import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";
import { useState } from "react";
import { AuthFlowType, FLOW_CONFIGS } from "@/config/SuccessPageFlowConfig";

import { Button } from "@/components/ui/button";
import Footer from "@/components/footer/Footer";
import Header from "@/components/header/Header";

import { cn } from "@/utils/utils";

import ButtonContainer from "@/components/button-container";
import { CloseMessage } from "@/utils/send-message/send-message";
import useFooterDisplayMode from "@/hooks/useFooterDisplayMode";

export default function SuccessPage() {
    const history = useHistory();
    const location = useLocation<any>();
    const { t } = useTranslation();
    const { displayMode, excludeAssetKey } = useFooterDisplayMode();

    const [loading, setLoading] = useState(false);

    const action = location.state?.properties?.action || "";
    const isDeepLink = location.state?.properties?.isDeepLink || "";

    function handleSuccessAction() {  
        setLoading(true);
        if (isDeepLink) {
            CloseMessage();
            return;
        }

        history.push(flowConfig.home || "/site-credentials");
    }

    const flowConfig = FLOW_CONFIGS[action as AuthFlowType];

    return (
        <div className="flex flex-col justify-self-center items-center gap-10 pb-2 w-full">
            <Header
                title={t(flowConfig.labels.headerTitle)}
                subtitle={cn(t(flowConfig.labels.headerSubtitle || ""))}
                showLoading={loading}
                showBackButton={false}
            />
            {flowConfig.flow === AuthFlowType.SC_LOYALTYCARD_DEFINITION && displayMode !== "none" && (
                <div
                    role="note"
                    aria-label={t(displayMode === "carousel" ? "accessibility.signin.icons_carousel" : "accessibility.signin.icons")} className="flex flex-col">
                    <Footer
                        contextualInformationVisible
                        displayMode={displayMode}
                        excludeAssetKey={excludeAssetKey}
                    />
                </div>
            )}
            <ButtonContainer>
                <Button
                    disabled={loading}
                    onClick={handleSuccessAction}
                >
                    {isDeepLink ? t(flowConfig.labels.nextButton.deeplink) : t(flowConfig.labels.nextButton.normal)}
                </Button>
            </ButtonContainer>
        </div>
    );
}